// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-salaries",
  SummaryList: "/pyr/productivity-salaries/summary",
  ViewPayslip: "/pyr/view-productivity-payslip",
  SendPayslip: "/pyr/send-productivity-payslip",
  BankTransfer: "/pyr/payrolls/bank-transfer",
  PayslipLog: "/pyr/payslip-log",
  ApprovalStatus: "/pyr/productivity-salaries/approval-status",
  ViewPayslipSummary: "/pyr/productivity-salaries/summary/view-payslip",

  List13thSalary: "/pyr/get-13th",
};
